var React = require('react');

function NavIconYourSettings (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.21758 11.375H10.0297C9.81641 9.89023 8.54219 8.75 6.99727 8.75H5.24727C3.70508 8.75 2.42812 9.89023 2.21484 11.375H2.21758ZM0 2.625C0 1.65977 0.784766 0.875 1.75 0.875H10.5C11.4652 0.875 12.25 1.65977 12.25 2.625V11.375C12.25 12.3402 11.4652 13.125 10.5 13.125H1.75C0.784766 13.125 0 12.3402 0 11.375V2.625ZM6.125 7.4375C6.64714 7.4375 7.1479 7.23008 7.51712 6.86087C7.88633 6.49165 8.09375 5.99089 8.09375 5.46875C8.09375 4.94661 7.88633 4.44585 7.51712 4.07663C7.1479 3.70742 6.64714 3.5 6.125 3.5C5.60286 3.5 5.1021 3.70742 4.73288 4.07663C4.36367 4.44585 4.15625 4.94661 4.15625 5.46875C4.15625 5.99089 4.36367 6.49165 4.73288 6.86087C5.1021 7.23008 5.60286 7.4375 6.125 7.4375Z","fill":"currentColor"}));
}

NavIconYourSettings.defaultProps = {"viewBox":"0 0 13 14","fill":"currentColor"};

module.exports = NavIconYourSettings;

NavIconYourSettings.default = NavIconYourSettings;
